import React, { useState, useEffect, useMemo } from "react";
import LocalizedDatePicker from '../../../component/LocalizedDatePicker/LocalizedDatePicker'
import { useTranslation } from '../../../context/LanguageContext'
import { callGetStatisticReportCampaignOverviewV3 } from '../../../services/statisticReports/CampaignOverviewV2StatisticReportService'
import { resetWindow, getRedisDateFormat, getDateFormat } from '../../../services/UtilService'
import './CampaignOverviewV3StatisticReport.css'
import { ROLE_ADV, ROLE_DIRECTOR, ROLE_MANAGER } from "../../../config/CommonConfig";

export default () => {
  const { t } = useTranslation()
  const [dataSource, setDataSource] = useState([])
  const agentTypes = useMemo(() => [
    { key: '1', label: t('statisticReport.freshCampaign') },
    { key: '2', label: t('statisticReport.resellCampaign') },
    { key: '0', label: t('statisticReport.allCampaign') },
  ], [t])
  const dateTypes = useMemo(() => [
    { key: '1', label: t('statisticReport.viewByCreatedDate'), value: 'createdate' },
    { key: '2', label: t('statisticReport.viewByModifiedDate'), value: 'modifydate' },
  ], [t])
  const [dateType, setDateType] = useState("createdate")
  const role = localStorage.getItem("role")

  const [query, setquery] = useState({
    valid: false,
    agentType: "1",
    dateFrom: undefined,
    dateTo: undefined
  })

  const headerDefault = useMemo(() => [
    { label: t('hsReport.columns.agent'), rowspan: 2, colspan: 0, scope: "rowgroup" },
    { label: t('report.columns.team'), rowspan: 2, colspan: 0, scope: "rowgroup" },
    { label: t('report.columns.agentName'), rowspan: 2, colspan: 0, scope: "rowgroup" },
    { label: t('hsReport.columns.leads'), rowspan: 2, colspan: 0, scope: "rowgroup" },
    { label: t('hsReport.columns.new'), rowspan: 2, colspan: 0, scope: "rowgroup" },
    { label: t('report.campaignOverviewV2.uncall'), rowspan: 0, colspan: 5, scope: "colgroup" },
    { label: t('report.campaignOverviewV2.callback'), rowspan: 0, colspan: 4, scope: "colgroup" },
    { label: t('hsReport.columns.urgent'), rowspan: 2, colspan: 0, scope: "rowgroup" },
    { label: t('report.campaignOverviewV2.approved'), rowspan: 0, colspan: 6, scope: "colgroup" },
    { label: t('report.campaignOverviewV2.reject'), rowspan: 2, colspan: 0, scope: "rowgroup" },
    { label: t('hsReport.columns.trash'), rowspan: 2, colspan: 0, scope: "rowgroup" },
    { label: t('report.campaignOverviewV2.closed'), rowspan: 2, colspan: 0, scope: "rowgroup" },
    { label: t('hsReport.columns.arQa'), rowspan: 2, colspan: 0, scope: "rowgroup" },
    { label: t('report.columns.arQc'), colKey: 'AR_QC', rowspan: 2, colspan: 0, scope: "rowgroup" },
    { label: t('report.campaignOverviewV2.attempt12'), rowspan: 0, colspan: 0, scope: "col" },
    { label: t('report.campaignOverviewV2.attempt35'), rowspan: 0, colspan: 0, scope: "col" },
    { label: t('report.campaignOverviewV2.attempt68'), rowspan: 0, colspan: 0, scope: "col" },
    { label: t('report.campaignOverviewV2.attempt8plus'), rowspan: 0, colspan: 0, scope: "col" },
    { label: t('report.campaignOverviewV2.total'), rowspan: 0, colspan: 0, scope: "col" },
    { label: t('report.campaignOverviewV2.abbrevP'), rowspan: 0, colspan: 0, scope: "col" },
    { label: t('report.campaignOverviewV2.abbrevC'), rowspan: 0, colspan: 0, scope: "col" },
    { label: t('report.campaignOverviewV2.abbrevNp'), rowspan: 0, colspan: 0, scope: "col" },
    { label: t('report.campaignOverviewV2.total'), rowspan: 0, colspan: 0, scope: "col" },
    { label: t('report.campaignOverviewV2.abbrevN'), rowspan: 0, colspan: 0, scope: "col" },
    { label: t('report.campaignOverviewV2.abbrevV'), rowspan: 0, colspan: 0, scope: "col" },
    { label: t('report.campaignOverviewV2.abbrevP'), rowspan: 0, colspan: 0, scope: "col" },
    { label: t('report.campaignOverviewV2.abbrevD'), rowspan: 0, colspan: 0, scope: "col" },
    { label: t('report.campaignOverviewV2.abbrevC'), rowspan: 0, colspan: 0, scope: "col" },
    { label: t('report.campaignOverviewV2.total'), rowspan: 0, colspan: 0, scope: "col" },
  ].filter(item => !(![ROLE_MANAGER, ROLE_DIRECTOR, ROLE_ADV].includes(role) && item.colKey === 'AR_QC')), [t, role]);

  useEffect(() => {
    resetWindow()
  }, [])

  const onQueryChange = (e) => {
    const name = e.target.name
    const value = e.target.value
    query.valid = false;

    query[name] = value
    if(query.dateFrom && query.dateTo) {
      query.valid = query.dateFrom.getTime() <= query.dateTo.getTime()
    }
    setquery({ ...query })
  }

  const onSearch = (e) => {
    var obj = {
      agentType: query.agentType,
      typeDate: dateType,
      dateFrom: '',
      dateTo: ''
    }
    obj.dateFrom = getDateFormat(query.dateFrom, 'yyyy-MM-dd') + ' 00:00:00'
    obj.dateTo = getDateFormat(query.dateTo, 'yyyy-MM-dd') + ' 23:59:59'
    let callFns = []
    callFns = [callGetStatisticReportCampaignOverviewV3(obj)]
    Promise.all(callFns).then(rest => {
      setDataSource(rest[0][0] || [])
      document.getElementById('redisDateTab').innerHTML = t('statisticReport.lastUpdatedAt', { time: getRedisDateFormat(rest[0][1]) })
    })
  }

  return (
    <div className="w-100 mt-2">
      <div className='panelDefault'>
      <div className='panelHeader'>{dateType === 'createdate' ? t('statisticReport.leadsCountedByCreatedShort') : t('statisticReport.leadsCountedByModifiedShort')}</div>
      <div className="d-flex flex-column" style={{ padding: '10px'}}>
            <div className="form-row mt-2" style={{ alignItems: 'center'}}>
                <div className="form-group col-md-2">
                    <label htmlFor="fltDateFrom">{dateType === 'createdate' ? t('statisticReport.createdDateFrom') : t('statisticReport.modifiedDateFrom')}</label>
                    <div className="form-control border-0 p-0">
                        <LocalizedDatePicker id="fltDateFrom"
                            name="dateFrom"
                            selected={query.dateFrom}
                            maxDate={query.dateTo ? query.dateTo : new Date()}
                            dateFormat="dd/MM/yyyy"
                            onChange={date => onQueryChange({ target: { name: "dateFrom", value: date } })}
                            className="form-control"></LocalizedDatePicker>
                    </div>
                </div>
                <div className="form-group col-md-2">
                    <label htmlFor="fltDateTo">{dateType === 'createdate' ? t('statisticReport.createdDateTo') : t('statisticReport.modifiedDateTo')}</label>
                    <div className="form-control border-0 p-0">
                        <LocalizedDatePicker id="fltDateTo"
                            name="dateTo"
                            selected={query.dateTo}
                            maxDate={new Date()}
                            minDate={query.dateFrom ? query.dateFrom : null}
                            dateFormat="dd/MM/yyyy"
                            onChange={date => onQueryChange({ target: { name: "dateTo", value: date } })}
                            className="form-control"></LocalizedDatePicker>
                    </div>
                </div>
                <div className="form-group col-md-2">
                    <label htmlFor="fltCampaign">{t('statisticReport.campaign')}</label>
                    <div className="form-control border-0 selectCustom w-100 p-0" style={{ height: '30px'}}>
                      <select className="w-100" style={{ borderRadius: '1.25rem'}} id="fltCampaign" value={query.agentType} onChange={e => { setquery({ ...query, agentType: e.target.value }) }}>
                        {agentTypes.map(agtType => <option key={agtType.key} value={agtType.key}>{agtType.label}</option>)}
                      </select>
                    </div>
                </div>
                <div className="selectCustom form-group col-md-2" style={{ height: '30px', marginTop: '7px' }}>
                  <select className="w-100" value={dateType} onChange={e => { setDateType(e.target.value) }}>
                    {dateTypes.map(item => <option key={item.key} value={item.value}>{item.label}</option>)}
                  </select>
                </div>
                <div className="form-group col-md-2 mt-4">
                  <button id="btnSearch" disabled={!query.valid} className="form-control w-50 border-0 btn btn-success" onClick={e => onSearch(e)}>{t('statisticReport.search')}</button>
                </div>
            </div>
        </div>
    </div>
    <div className='table-Wrap'>
      <table className="table-compoment mt-2 w-100 table-no-pad">
        <colgroup span="22"></colgroup>
        <thead className="text-center">
          <tr>
            {headerDefault.map((col, index) => 
              col.colspan <= 0 && col.rowspan > 0 ? (
                <th key={index} rowSpan={col.rowspan} scope={col.scope} className="thTableV2">
                  {col.label}
                </th>
              ) :
              col.colspan > 0 && col.rowspan <= 0 && (
                <th key={index} colSpan={col.colspan} scope={col.scope} className="thTableV2">
                  {col.label}
                </th>
              )
            )}
          </tr>
          <tr>
            {headerDefault.map((col, index) =>
              col.colspan <= 0 && col.rowspan <= 0 && <th key={index} scope="col" className="thTableV2">{col.label}</th>
            )}
          </tr>
        </thead>
        {
          dataSource.length > 0 ? (
            <tbody>
              {
                dataSource.map((row, index) => {
                  let colOptions = Object.keys(row).map(function(key, id) {
                  let tdCol = key.includes('%') 
                                ? <td key={key} className="tdTableV2">{row[key][0] ? row[key][0] : 0} <span className="percent">{'('+ (row[key][1] ? row[key][1] : 0) + '%)'}</span></td> 
                                  : id <= 1
                                  ? <td key={key} className="text-center tdTableV2">{row[key]}</td> 
                                : <td key={key} className="tdTableV2">{row[key]}</td>;
                    return tdCol
                  })
                  if (index <= 0) {
                    return <tr key={index} className="text-right total">{colOptions}</tr>
                  } else {
                    return <tr key={index} className="text-right">{colOptions}</tr>
                  }
                }
                )
              }
            </tbody>
          ) : (
            <tbody>
              <tr className="text-center"><td colSpan={100}>{t('report.noData')}</td></tr>
            </tbody>
          )       
        }        
      </table>
      </div>
      <div className="row"><div id="redisDateTab" className="col-12 small text-right"></div></div>
    </div>
  );
};
